import React, { useState, useEffect } from "react";
import { Hide, Show } from "react-iconly";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import "./masterSignUp.scss";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { masterLogin } from "../../services/auth.service";
import { useDispatch, useSelector } from "react-redux";
import { loginr, selectUser } from "../../slice/authSlice";
import { toast_success, toast_warning } from "../../config/Constant";

const MasterLogin = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector(selectUser);

  const [input, setInput] = useState({
    email: "",
    password: "",
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [remember, setRemember] = useState(false);
  const [isVisible, setVisiblePass] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      let storedEmail = await localStorage.getItem("loginemail");
      let storedPassword = await localStorage.getItem("loginpassword");

      if (storedEmail && storedPassword) {
        setInput({
          email: storedEmail || "",
          password: storedPassword || "",
        });
        setRemember(true);
      }
    };
    fetchData();
  }, []);

  // Redirect if already logged in
  useEffect(() => {
    const accessToken = localStorage.getItem("accessToken");
    if (user?.token || accessToken) {
      if (user?.userType === "provider") {
        navigate("/provider/dashboard");
      } else if (user?.userType === "user") {
        navigate("/");
      }
    }
  }, [user, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      try {
        const payload = {
          ...input,
          deviceType: "web",
        };
        if (remember) {
          localStorage.setItem("loginemail", input.email);
          localStorage.setItem("loginpassword", input.password);
        } else {
          localStorage.removeItem("loginemail");
          localStorage.removeItem("loginpassword");
        }
        setLoading(true);
        const res = await masterLogin(payload);
        if (res?.data?.status === true) {
          toast.success(res?.data?.message, toast_success);
          await dispatch(loginr(res.data));
          localStorage.setItem("accessToken", res.data.token);

          if (res.data.userType === "provider") {
            navigate("/provider/dashboard");
          } else if (res.data.userType === "user") {
            navigate("/");
          }
        } else {
          toast.error(
            res?.response?.data?.message || res?.data?.message || "Login failed. Please check your credentials.",
            toast_warning
          );
        }
      } catch (error) {
        console.error("Login error:", error);
        toast.error(
          error?.response?.data?.message || "An error occurred. Please try again.",
          toast_warning
        );
      } finally {
        setLoading(false);
      }
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInput((prev) => ({
      ...prev,
      [name]: value,
    }));
    setErrors((prev) => ({
      ...prev,
      [name]: undefined,
    }));
  };

  const validateForm = () => {
    let valid = true;
    const newErrors = {};

    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!input.email || !emailRegex.test(input.email)) {
      newErrors.email = "Please enter a valid email address";
      valid = false;
    }

    // Password validation
    if (!input.password || input.password.length < 6) {
      newErrors.password = "Password must be at least 6 characters long";
      valid = false;
    }

    setErrors(newErrors);
    return valid;
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSubmit(e);
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="header-section">
          <h2 className="login-title">Master Login</h2>
          <p className="login-subtitle">
            Welcome back! Please sign in to your account.
          </p>
        </div>

        <Form onSubmit={handleSubmit} className="login-form">
          <Form.Group className="mb-3" controlId="email">
            <Form.Label className="form-label">Email Address</Form.Label>
            <Form.Control
              type="email"
              name="email"
              value={input.email || ""}
              onChange={handleChange}
              onKeyPress={handleKeyPress}
              placeholder="Enter your email address"
              className={errors.email ? "is-invalid" : ""}
              disabled={loading}
            />
            {errors.email && (
              <div className="error-message">{errors.email}</div>
            )}
          </Form.Group>

          <Form.Group className="mb-3" controlId="password">
            <Form.Label className="form-label">Password</Form.Label>
            <div className="password-wrapper">
              <Form.Control
                type={isVisible ? "text" : "password"}
                name="password"
                value={input.password || ""}
                onChange={handleChange}
                onKeyPress={handleKeyPress}
                placeholder="Enter your password"
                className={errors.password ? "is-invalid" : ""}
                disabled={loading}
              />
              <button
                type="button"
                className="eye-toggle-btn"
                onClick={() => setVisiblePass(!isVisible)}
                disabled={loading}
                aria-label={isVisible ? "Hide password" : "Show password"}
              >
                {isVisible ? (
                  <Show size={20} />
                ) : (
                  <Hide size={20} />
                )}
              </button>
            </div>
            {errors.password && (
              <div className="error-message">{errors.password}</div>
            )}
          </Form.Group>

          <div className="options-row">
            <Form.Check
              type="checkbox"
              id="rememberMe"
              label="Remember me"
              checked={remember}
              onChange={(e) => setRemember(e.target.checked)}
              disabled={loading}
              className="remember-checkbox"
            />
          </div>

          {loading ? (
            <Button
              type="submit"
              variant="primary"
              size="lg"
              className="w-100 submit-btn"
              disabled
            >
              <div className="loader-wrapper">
                <div className="loader"></div>
                <span className="loader-text">Signing in...</span>
              </div>
            </Button>
          ) : (
            <Button
              type="submit"
              variant="primary"
              size="lg"
              className="w-100 submit-btn"
            >
              Sign In
            </Button>
          )}
        </Form>
      </div>
    </div>
  );
};

export default MasterLogin;
